import React from "react";

function ReturnPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-6">
      <div className="max-w-3xl mx-auto bg-white shadow-md rounded-lg p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6 border-b pb-4">
          Return Policy
        </h1>

     <p className="text-gray-700 leading-relaxed">
          
We have a 5-day return policy, which means you have 5 days after receiving your item
to request a return.
Once the return product is received it will be inspected and the return will be approved
within 2 days

          </p>   
      </div>
    </div>
  );
}

export default ReturnPolicy;
